import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseComponent} from "../../../../../../../base/components/base.component";
import {EventBusService} from "../../../../../../../base/services/eventbus/event-bus.service";
import {Router} from "@angular/router";
import {SubscriptionContainerService} from "../../../../../../../base/services/subscription-container.service";
import {FileListComponent} from "../file-list/file-list.component";
import {FileRequisition, IImage, IImageSlice, imgToSlice} from "../../models/file.model";
import {DialogService} from "../../../../utility/components/popup/dialog.service";

@Component({
  selector: 'app-file-picker',
  templateUrl: './filepicker.component.html',
  styleUrls: ['./filepicker.component.scss']
})
export class FilePickerComponent extends BaseComponent {
  @Input() title: string = 'Upload Images'
  @Input() msg: string = ''
  @Input() multiSelect: boolean = false

  @Input() required: boolean = false
  @Input() existingImages: IImageSlice[] = []

  @Input() uniqueNamespace: string
  @Output() onUploaded: EventEmitter<IImageSlice[]> = new EventEmitter<IImageSlice[]>()
  @Output() onFileRemoved: EventEmitter<IImageSlice> = new EventEmitter<IImageSlice>()

  protected componentName(): string {
    return FilePickerComponent.name;
  }

  constructor(eventBus: EventBusService,
              router: Router,
              subContainer: SubscriptionContainerService,
              private popup: DialogService<IImage[]>
  ) {
    super(eventBus, router, subContainer)
    this.loading = false
    if (this.uniqueNamespace == null)
      this.uniqueNamespace = this.getUniqueId(4)
  }

  ngOnInit(): void {
  }

  onPickerClicked(event: Event) {
    event.preventDefault()
    let dialogRef = this.popup.open<FileRequisition>(FileListComponent, {
      id: null,
      fileRequisitionDef: {
        pickerTitle: this.title,
        multiSelect: this.multiSelect,
        required: this.required,
        existingImages: this.existingImages,
        namespace: this.uniqueNamespace
      }
    })
    let component = dialogRef.componentInstance
    component.onCompleted.subscribe((images: IImage[]) => {
      this.onUploaded.emit(images.map(img => imgToSlice(img)))
    })
  }

  removeExImage(event: Event, img: IImageSlice) {
    console.log(img)
    event.stopPropagation();
    this.onFileRemoved.emit(img)
  }


  getUniqueId(parts: number): string {
    const stringArr = [];
    for (let i = 0; i < parts; i++) {
      // tslint:disable-next-line:no-bitwise
      const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      stringArr.push(S4);
    }
    return stringArr.join('-');
  }

}
